export default {
    vmLogUpdated: 'VM Log updated',
    Errored: 'Errored',
    Finished: 'Finished',
    Waiting: 'Waiting',
    Running: 'Running',
    'Cleanup after abort': 'Aborted',
    Aborting: 'Aborting',
    STARTED: 'STARTED',
    DATA_ARRIVED_ON_VM: 'DATA ARRIVED ON VM',
    CAD_IMPORT: 'CAD IMPORT',
    SINGLE_EXTRACT: 'SINGLE EXTRACT',
    GROUP_EXTRACT: 'GROUP EXTRACT',
    TRANSFER_DATA_TO_VHUB: 'TRANSFER DATA TO VHUB',
    CREATING_ASSETS: 'CREATING ASSETS',
    CREATING_INSTANCES: 'CREATING INSTANCES',
    ATTACHING_METADATA: 'ATTACHING METADATA',
    SETTING_METAVALUES: 'SETTING METAVALUES',
    SETTING_CUSTOM_META_VALUES: 'SETTING CUSTOM META VALUES',
    FINISHED: 'FINISHED',
    PROCESSED: 'PROCESSED',
    PROCESSING_INSTANCES: 'PROCESSING INSTANCES',
    PROCESSING_MATERIALS: 'PROCESSING MATERIALS',
    timePrediction: 'Time prediction',
    geometries: 'parts',
    vertices: 'vertices',
    groups: 'groups',
    createdby: 'created By',
    updatedby: 'updated by',
    totaltime: 'Total time',
    vmtime: 'VM time',
    instanceUpdating: 'Instance updating',
    dataprocessing: 'Meta data update',
    createVersion: 'Create version',
    restoreVersion: 'Restore version',
    deleteVersion: 'Delete version',
    extract: 'Import',
    update: 'Update',
    convertAssembly: 'Convert assembly',
    dataprocessingAbortMessage: 'Do you really want to abort the meta data update?',
    dataprocessingAbortedMessage: 'The meta data update has been aborted.',
    applyMaterialAbortMessage: 'Do you really want to abort the material application?',
    applyMaterialAbortedMessage: 'The material application has been aborted.',
    convertHelperAbortMessage: 'Do you really want to abort the conversion?',
    convertHelperAbortedMessage: 'The conversion has been aborted.',
    convertAssemblyAbortMessage: 'Do you really want to abort the assembly conversion?',
    convertAssemblyAbortedMessage: 'The assembly conversion has been aborted.',
    instanceUpdatingAbortMessage: 'Do you really want to abort the instance update?',
    instanceUpdatingAbortedMessage: 'The instance update has been aborted.',
    filterAbortMessage: 'Do you really want to abort the filtering?',
    filterAbortedMessage: 'The filtering has been aborted.',
    extractAbortMessage: 'Do you really want to abort the import? The process will be stopped and your CAD files will be removed from our systems.',
    extractAbortedMessage: 'The import has been aborted. Your CAD files have been removed from our systems. If the last status is one of the following steps, you do not need to take any further action. If it is after that, then you will most likely need to revert your assembly to a previous version: {steps}',
    updateAbortMessage: 'Do you really want to abort the update? The process will be stopped and your CAD files will be removed from our systems.',
    updateAbortedMessage: 'The update has been aborted. Your CAD files have been removed from our systems. If the last status is one of the following steps, you do not need to take any further action. If it is after that, then you will most likely need to revert your assembly to a previous version: {steps}',
    SuccessfullyInmported: 'Successfully imported',
    ErroredImporting: 'Errored importing',
    deleteTaskAndCADFiles: 'Delete process and uploaded files',
    cleanup: 'Abort Cleanup',
    cannotStartProcessIsRunning: 'Cannot start, process is running',
    importAbort: 'Abort',
    importStart: 'Start import',
    exportGroups: 'Export groups',
    exportParts: 'Export parts',
    exportPreviews: 'Export preview images'
}